import { Wrapper, Box } from './styles';

const numOfBoxes = 8;

const SeeThroughBoxes = ({ position }) => {
  return (
    <Wrapper style={{ ...position }}>
      {[...new Array(numOfBoxes)].map((_, ind) => (
        <Box key={ind}></Box>
      ))}
    </Wrapper>
  );
};

export default SeeThroughBoxes;
